import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import UserSettingsContent from "./UserSettingsContent";

function UserSettingsModal({ isOpen = true, onClose }) {
	const { t } = useTranslation("userProfile");

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("settings.title")}
			maxWidth="960px"
			maxHeight="90vh"
			overflowY="auto"
			fullScreenOnMobile
			closeButtonPosition="start"
			hideHeader
			closeLabel={t("settings.close")}
		>
			<UserSettingsContent onClose={onClose} />
		</Modal>
	);
}

UserSettingsModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};

export default UserSettingsModal;
